// extracted by mini-css-extract-plugin
module.exports = {"emptyNotifications":"EmptyNotifications_emptyNotifications__18_EC","description":"EmptyNotifications_description__4IdmA"};